/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Exclusion_RemoveInputs */

const en_us2_offline_kind_exclusion_remove = /** @type {(inputs: Offline_Kind_Exclusion_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise back among the options`)
};

const pt_br2_offline_kind_exclusion_remove = /** @type {(inputs: Offline_Kind_Exclusion_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício de volta às opções`)
};

const es_419_offline_kind_exclusion_remove = /** @type {(inputs: Offline_Kind_Exclusion_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicio de vuelta entre las opciones`)
};

const pt_pt2_offline_kind_exclusion_remove = /** @type {(inputs: Offline_Kind_Exclusion_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício de volta às opções`)
};

const fr_fr2_offline_kind_exclusion_remove = /** @type {(inputs: Offline_Kind_Exclusion_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice de retour dans les options`)
};

const de_de2_offline_kind_exclusion_remove = /** @type {(inputs: Offline_Kind_Exclusion_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung wieder unter den Optionen`)
};

const it_it2_offline_kind_exclusion_remove = /** @type {(inputs: Offline_Kind_Exclusion_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio di nuovo tra le opzioni`)
};

/**
* | output |
* | --- |
* | "Exercise back among the options" |
*
* @param {Offline_Kind_Exclusion_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_exclusion_remove = /** @type {((inputs?: Offline_Kind_Exclusion_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Exclusion_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_exclusion_remove(inputs)
	if (locale === "es-419") return es_419_offline_kind_exclusion_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_exclusion_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_exclusion_remove(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_exclusion_remove(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_exclusion_remove(inputs)
	return en_us2_offline_kind_exclusion_remove(inputs)
});
export { offline_kind_exclusion_remove as "offline.kind_exclusion_remove" }